<style>
    .footer-container{
        bottom: 0%;
        min-height: 100vh;
        display: block;
    }
    
    </style>

<div class="footer-container"> 
   
</div>